import React, { useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";

import { updateTournament } from "../../redux/slices/tournamentSlice";
import ClubbieButton from "../ClubbieButton/ClubbieButton";
import ClubbieModal from "../Modal/ClubbieModal";
import ClubbieInput from "../ClubbieInput/ClubbieInput";

/**
 * UpdateTournamentVenueName - JSX component with Tailwind CSS
 * Modal for updating tournament venue name
 * 
 * Features:
 * - Single text input for venue name
 * - Updates tournament.matchVenue.venue field
 * - Toast notifications for success/error
 * - Loading state management
 * 
 * @param {boolean} isOpen - Modal visibility state
 * @param {function} onClose - Callback to close modal
 */
const UpdateTournamentVenueName = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const selectedTournament = useSelector(
    (state) => state.tournament.selectedTournament
  );

  const [isLoading, setIsLoading] = useState(false);

  const [venueName, setVenueName] = useState(
    selectedTournament?.matchVenue?.venue || ""
  );

  const handleVenueNameChange = (e) => {
    setVenueName(e.target.value);
  };

  const handleUpdateVenueName = async () => {
    try {
      setIsLoading(true);
      const updateData = {
        matchVenue: {
          ...selectedTournament?.matchVenue,
          venue: venueName,
        },
      };

      const result = await dispatch(
        updateTournament({
          id: selectedTournament?.id,
          updateData,
        })
      ).unwrap();

      if (result) {
        toast.success("Competition venue name updated successfully!");
        onClose();
      }
    } catch (error) {
      toast.error(error.message || "Failed to update competition venue name");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ClubbieModal isOpen={isOpen} toggle={onClose} title="Update Venue Name">
      <div className="flex flex-col gap-4 p-6">
        <ClubbieInput
          type="text"
          placeholder="Add Your Venue Details"
          value={venueName}
          onChange={handleVenueNameChange}
          className="w-full"
        />

        <ClubbieButton
          className="w-full"
          onClick={handleUpdateVenueName}
          disabled={isLoading || !venueName}
          isLoading={isLoading}
        >
          Update
        </ClubbieButton>
      </div>
    </ClubbieModal>
  );
};

export default UpdateTournamentVenueName;
